import styled from 'styled-components'

const StyledFooter = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  z-index:  ${({ theme }) => theme.zIndex.fixed};
  position: relative;

  .footer-links {
    max-width: 1044px;
    text-align: center;

    a {
      font-size: 13px;
      font-weight: 500;
      margin: 0 15px;
      
      color: ${({ theme }) => theme.colors.gray[900]};

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        text-decoration: underline;
      }
    }
  }
`

export default StyledFooter
